import { Button, Icon, Heading } from "@/ui"
import { useAccount, useI18n } from "@/hooks"
import { ParagraphsController } from "@/paragraphs"
import { useRouter } from "next/router"

const ConseilsNode = ({ node }) => {
	const { loginUrl, isAuthenticated } = useAccount()
	const { t } = useI18n()
	const router = useRouter()

	const onClose = () => router.push("/je-minforme")
	if (node.field_vactory_flag) {
		if (isAuthenticated) {
			return (
				<>
					{/* <Heading>{node.title}</Heading> */}
					<div className="vactory-paragrphs-wrapper">
						{node.field_vactory_paragraphs &&
							node.field_vactory_paragraphs.map((paragraph) => (
								<ParagraphsController
									key={paragraph.id}
									data={paragraph}
									hasAMP={false}
								/>
							))}
						{/* {node.field_vactory_excerpt && (
							<div>
								<Wysiwyg html={node.field_vactory_excerpt.value} />
							</div>
						)} */}
					</div>
				</>
			)
		} else {
			return (
				<div className="fixed z-[60] left-0 top-0 h-full w-full  bg-search flex justify-center items-center">
					<div className="max-w-6xl mx-auto py-11 px-4">
						<div className="z-1 relative overflow-hidden bg-white md:max-w-[730px] w-full max-w-full md:w-[730px] mx-auto">
							<Button
								className="absolute top-4 right-4 bg-transparent border-0"
								onClick={onClose}
							>
								<Icon id="close" className="rtl-icon" width="17" height="17" />
							</Button>
							<div className="text-center px-5 md:px-10 py-11">
								<svg
									aria-hidden="true"
									width="50"
									height="50"
									className="w-18 h-16 md:w-36 md:h-36 mx-auto mb-9"
									viewBox="0 0 907 1024"
								>
									<path d="M167.26 949.707c1.54-1.63 2.757-3.54 3.58-5.626 0.873-2.050 1.336-4.251 1.365-6.479 0.040-6.926-4.114-13.187-10.51-15.844-6.397-2.655-13.764-1.179-18.641 3.74l-2.046 2.557c-0.645 0.951-1.163 1.982-1.534 3.069-0.493 0.967-0.837 2-1.023 3.069-0.19 1.127-0.304 2.267-0.342 3.41 0.066 4.513 1.832 8.834 4.944 12.104 1.63 1.54 3.54 2.757 5.626 3.58 6.359 2.571 13.635 1.171 18.581-3.58z"></path>
									<path d="M871.146 613.704h-17.047v-136.379c0.136-58.977-27.547-114.566-74.695-149.998s-108.243-46.557-164.855-30.022c-1.856-13.069-7.47-25.317-16.162-35.254v-90.623c3.332-40.334-9.481-80.343-35.63-111.234-35.014-39.941-91.85-60.194-168.938-60.194s-133.924 20.253-168.938 60.194c-26.144 30.893-38.96 70.9-35.63 111.234v90.623c-10.938 12.366-16.997 28.292-17.047 44.801v68.189c0.012 20.625 9.379 40.13 25.469 53.034 11.783 44.587 32.078 86.474 59.768 123.354v56.478c0.036 16.473-9.008 31.626-23.525 39.413l-152.062 83.038c-49.388 26.941-80.123 78.705-80.123 134.963v72.28c0 9.415 7.633 17.047 17.047 17.047h68.189c9.415 0 17.047-7.633 17.047-17.047 0-9.415-7.633-17.047-17.047-17.047h-51.142v-55.233c0.020-43.778 23.941-84.053 62.375-105.011l151.96-82.986c25.535-13.74 41.435-40.42 41.373-69.417v-62.393c0.002-4.001-1.404-7.875-3.971-10.944-27.611-35.586-47.434-76.579-58.182-120.32-0.973-4.313-3.598-8.071-7.314-10.466-9.801-6.277-15.74-17.103-15.768-28.741v-68.191c0.022-9.647 4.181-18.821 11.421-25.195 3.58-3.23 5.624-7.827 5.626-12.65v-98.534c0-0.747-0.050-1.492-0.154-2.233-2.525-31.005 7.276-61.754 27.275-85.577 28.298-32.237 76.509-48.567 143.351-48.567 66.586 0 114.712 16.23 142.994 48.227 20.055 23.945 29.97 54.772 27.635 85.919-0.102 0.739-0.154 1.486-0.154 2.233v98.534c0.002 4.823 2.046 9.417 5.626 12.65 7.242 6.375 11.399 15.548 11.421 25.195v3.648c-62.707 32-102.208 96.425-102.284 166.825v136.377h-17.047c-18.831 0-34.095 15.265-34.095 34.095v255.71c0.048 5.708 0.503 11.405 1.364 17.047h-205.93c-9.415 0-17.047 7.633-17.047 17.047 0 9.415 7.633 17.047 17.047 17.047h216.245c19.728 41.591 61.62 68.127 107.654 68.189h238.663c65.873-0.076 119.257-53.457 119.331-119.331v-255.71c0-18.829-15.265-34.093-34.093-34.093zM513.152 477.325c0-84.734 68.692-153.426 153.426-153.426s153.426 68.692 153.426 153.426v136.379h-306.852v-136.379zM785.909 988.745h-238.663c-40.49-0.052-75.377-28.53-83.531-68.189h49.438c9.415 0 17.047-7.631 17.047-17.047s-7.633-17.047-17.047-17.047h-51.142v-34.095h51.142c9.415 0 17.047-7.631 17.047-17.047s-7.633-17.047-17.047-17.047h-51.142v-34.095h51.142c9.415 0 17.047-7.631 17.047-17.047s-7.633-17.047-17.047-17.047h-51.142v-34.097h51.142c9.415 0 17.047-7.633 17.047-17.047 0-9.415-7.633-17.047-17.047-17.047h-51.142v-34.095h409.136v34.095h-51.142c-9.415 0-17.047 7.633-17.047 17.047 0 9.415 7.633 17.047 17.047 17.047h51.142v34.095h-51.142c-9.415 0-17.047 7.633-17.047 17.047s7.633 17.047 17.047 17.047h51.142v34.095h-51.142c-9.415 0-17.047 7.631-17.047 17.047s7.633 17.047 17.047 17.047h51.142v34.095h-51.142c-9.415 0-17.047 7.631-17.047 17.047s7.633 17.047 17.047 17.047h49.438c-8.157 39.661-43.043 68.141-83.533 68.191z"></path>
									<path d="M666.578 733.035c-24.88-0.048-46.166 17.858-50.381 42.376-4.215 24.52 9.867 48.505 33.334 56.772v37.232c0 9.415 7.631 17.047 17.047 17.047s17.047-7.633 17.047-17.047v-37.232c23.467-8.265 37.549-32.251 33.334-56.772-4.215-24.518-25.501-42.422-50.381-42.376zM666.578 801.225c-9.415 0-17.047-7.631-17.047-17.047s7.631-17.047 17.047-17.047c9.415 0 17.047 7.631 17.047 17.047s-7.631 17.047-17.047 17.047z"></path>
								</svg>
								<Heading variant="modal-mre">{t("Nx:Authentification requise")}</Heading>
								<p className="text-center">
									{t(
										"Nx: Pour visualiser ce contenu, nous vous invitons à renseigner vos codes d'accès à la plateforme @plateforme."
									)}
								</p>
							</div>
							<div className="grid md:grid-flow-col auto-cols-fr gap-4 px-5 pt-0 pb-4 md:gap-12 md:px-16 md:py-9">
								<Button variant="mre" onClick={onClose}>
									{t("Retour à la page précédente")}
								</Button>
								<Button href={loginUrl || ".#"} variant="secondary-mre">
									{t("Nx:S'identifier")}
								</Button>
							</div>
						</div>
					</div>
				</div>
			)
		}
	} else {
		return (
			<>
				{/* <Heading>{node.title}</Heading> */}
				<div className="vactory-paragrphs-wrapper">
					{node.field_vactory_paragraphs &&
						node.field_vactory_paragraphs.map((paragraph) => (
							<ParagraphsController key={paragraph.id} data={paragraph} hasAMP={false} />
						))}
					{/* {node.field_vactory_excerpt && (
						<Wysiwyg html={node.field_vactory_excerpt.value} />
					)} */}
				</div>
			</>
		)
	}
}

export default ConseilsNode
export const config = {
	id: "node--conseils",
	params: {
		fields: {
			"node--conseils":
				"field_vactory_paragraphs,created,field_vactory_excerpt,field_vactory_media_image,field_vactory_media,vcc_normalized,field_vactory_taxonomy_1,field_vactory_flag",
			"paragraph--vactory_component":
				"drupal_internal__id,paragraph_section,paragraph_identifier,paragraph_container,container_spacing,paragraph_css_class,paragraph_background_color,paragraph_background_image,field_vactory_component,field_vactory_title,field_background_color,field_paragraph_hide_lg,field_paragraph_hide_sm,field_position_image_x,field_position_image_y,field_size_image,field_vactory_flag,field_vactory_flag_2,paragraph_background_parallax",
			"paragraph--vactory_paragraph_multi_template":
				"drupal_internal__id,paragraph_section,paragraph_identifier,paragraph_container,container_spacing,paragraph_css_class,paragraph_background_color,paragraph_background_image,field_vactory_component,field_vactory_title,field_paragraph_introduction,field_vactory_paragraph_tab,field_background_color,field_multi_paragraph_type,field_paragraph_hide_lg,field_paragraph_hide_sm,field_position_image_x,field_position_image_y,field_size_image,field_vactory_flag,field_vactory_flag_2,paragraph_background_parallax",
			"media--image": "thumbnail",
			"file--image": "uri",
			"taxonomy_term--mre_conseils_theme": "name",
			"media--remote_video": "field_media_oembed_video",
		},
		include:
			"field_vactory_media_image,field_vactory_media,field_vactory_media.thumbnail,field_vactory_media_image.thumbnail,field_vactory_taxonomy_1,field_vactory_paragraphs,field_vactory_paragraphs.field_vactory_paragraph_tab,field_vactory_paragraphs.paragraph_background_image,field_vactory_paragraphs.paragraph_background_image.thumbnail",
	},
}
